import janetsirs from '../../media/janetsirs.jpg';

export const homeImageMap = {
  janetsirs,
};
